/*
 * @Author: shannyHuang
 * @Date: 2022-07-05 10:21:26
 * @LastEditors: brucexlliu
 * @LastEditTime: 2023-04-25 19:33:08
 * @FilePath: \wemeet-web-activity\src\components\Layout\index.tsx
 */
'use client';
import React, { FC, ReactElement, useContext, useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { AppContext } from '@utils/browser/app-context';
import ErrorBoundary from '../ErrorBoundary';
import '@tencent/tpm-meeting-active/lib/NavBanner/style';
import EventDetailNav from 'src/components/EventDetailNav';
import Layout from '@tencent/tpm-meeting-active/lib/Layout';
import '@tencent/tpm-meeting-active/lib/Layout/style';
import AccountHeader from '@component/AccoutInfo';
import { PC_LAYOUT_PAGE, HEADER_PAGE } from '@utils/layout-config';
import HostPageLayout from './HostLayout';

const { Body, Content } = Layout;
const PageLayout: FC<{
  children: ReactElement;
  className?: string;
  fullResponsive?: boolean;
  responsive?: boolean;
  full?: boolean;
  iswx?: boolean;
  ismeetingApp: boolean;
  isMiniprogram: boolean;
}> = ({ children, className, fullResponsive, full, responsive, ismeetingApp, isMiniprogram }) => {
  const { isMobile } = useContext(AppContext);
  const router = useRouter();
  const { pathname, query } = router;
  const hasLayout = PC_LAYOUT_PAGE.includes(pathname);
  const headerPage = HEADER_PAGE.includes(pathname);
  const [wemeetApp, setWemeetApp] = useState(ismeetingApp);

  useEffect(() => {
    // 判断是否是会议app
    if (!ismeetingApp && window.os.isWemeetApp) {
      setWemeetApp(true);
    }
  }, []);

  if (hasLayout && !isMobile) {
    return (
      <HostPageLayout
        className={className}
        fullResponsive={fullResponsive}
        full={full}
        responsive={responsive}
      >
        {children}
      </HostPageLayout>
    );
  }

  if (headerPage) {
    return (
      <ErrorBoundary>
        <Layout className={className} full={full} fullResponsive={fullResponsive}>
          <Body>
            {/* 支持从连接上携带是否显示头，有nh=1的就不显示头,小程序内也不显示头 */}
            {!wemeetApp && query.nh !== '1' && !isMiniprogram && <AccountHeader />}
            <Content showBackButton={false} backButtonText={null}>
              {React.cloneElement(children, { isMobile, key: 'app-page-layout-child' })}
            </Content>
          </Body>
        </Layout>
      </ErrorBoundary>
    );
  }
  // 具体活动的页面
  if (pathname.indexOf('/event') !== -1 && pathname !== '/event/[eventid]/registration') {
    return (
      <EventDetailNav>
        {React.cloneElement(children, { isMobile, key: 'app-page-layout-child' })}
      </EventDetailNav>
    );
  }
  return (
    <ErrorBoundary>
      {React.cloneElement(children, { isMobile, key: 'app-page-layout-child' })}
    </ErrorBoundary>
  );
};
export default PageLayout;
